export const getTitleDescriptionId = childComponent => {
    const layoutProps =
        // If the child component is a Loading component, we will access the props of the direct child
        childComponent.props?._dashprivate_layout?.type === 'Loading'
            ? childComponent.props?._dashprivate_layout?.props?.children?.props
            : // Otherwise, we can access the props of the given child component directly.
              childComponent.props?._dashprivate_layout?.props || {};

    return {
        title: childComponent.props?.title || layoutProps?.title || '',
        description:
            childComponent.props?.description || layoutProps?.description,
        id: childComponent.props?.id || layoutProps?.id,
    };
};
